// Lander "7 Reasons" — page.lander__7-reasons only

var l7rHeroCtaVisible = true;
var l7rHideZonesInView = 0;

function l7rSelectShade($shade) {
  var $card = $shade.closest("[data-l7r-product]");
  var available = $shade.data("available") === true || $shade.data("available") === "true";

  $card.find("[data-l7r-shade]").removeClass("is-active");
  $shade.addClass("is-active");
  $card.find("[data-l7r-shade-name]").text($shade.data("title"));
  $card.find("[data-l7r-price]").text($shade.data("price"));
  $card.find("[data-l7r-atc]").attr("data-id", $shade.data("id")).prop("disabled", !available);
  $card.find("[data-l7r-atc-label]").each(function () {
    $(this).text($(this).attr(available ? "data-label" : "data-soldout"));
  });
  l7rSwapTileImage($card, $shade);
}

function l7rSwapTileImage($card, $shade) {
  var img = $shade.attr("data-img");
  if (!img) return;

  var srcset = $shade.attr("data-srcset");
  var $tile = $card.find("[data-l7r-tile]");

  $tile.find("img.l7r-tile-old").remove();
  $tile.find("[data-l7r-tile-img], [data-l7r-tile-img-mob]").each(function () {
    var $old = $(this);
    var $new = $old.clone().attr({ src: img, srcset: srcset, loading: "eager" }).addClass("l7r-tile-fade is-variant");

    $old.removeAttr("data-l7r-tile-img data-l7r-tile-img-mob").addClass("l7r-tile-old");
    $new.one("load error", function () {
      requestAnimationFrame(function () {
        $new.addClass("is-in");
        setTimeout(function () {
          $old.remove();
          $new.removeClass("l7r-tile-fade is-in");
        }, 400);
      });
    });
    $old.after($new);
  });
}

function l7rPreloadShade($shade) {
  var img = $shade.attr("data-img");
  if (!img || $shade.data("l7rPreloaded")) return;
  $shade.data("l7rPreloaded", true);
  new Image().src = img;
}

function l7rAddToCart($btn) {
  var id = Number($btn.attr("data-id"));
  if (!id) return;

  $btn.addClass("loading");

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: "cell_cart_drawer" }),
  })
    .then(function (res) {
      if (!res.ok) throw res;
      return res.json();
    })
    .then(function (data) {
      if (typeof window.refreshCartDrawer === "function") window.refreshCartDrawer(false, data.sections);
      if (typeof window.openCartDrawer === "function") window.openCartDrawer(true);
    })
    .catch(function (err) {
      console.error("l7r add to cart failed", err);
    })
    .finally(function () {
      $btn.removeClass("loading");
    });
}

function l7rToggleFaq($q) {
  var $item = $q.closest(".l7r-faq__item");
  $item.toggleClass("is-open");
  $q.attr("aria-expanded", $item.hasClass("is-open"));
}

function l7rUpdateSticky() {
  var show = !l7rHeroCtaVisible && l7rHideZonesInView === 0;
  $("[data-l7r-sticky]").toggleClass("is-visible", show).attr("aria-hidden", !show);
}

function l7rInitSticky() {
  var cta = document.querySelector("[data-l7r-hero-cta]");
  if (!document.querySelector("[data-l7r-sticky]") || !("IntersectionObserver" in window)) return;

  if (cta) {
    new IntersectionObserver(function (entries) {
      l7rHeroCtaVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      l7rUpdateSticky();
    }).observe(cta);
  } else {
    l7rHeroCtaVisible = false;
  }

  var zoneObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.target.l7rInView === entry.isIntersecting) return;
      entry.target.l7rInView = entry.isIntersecting;
      l7rHideZonesInView += entry.isIntersecting ? 1 : -1;
    });
    l7rUpdateSticky();
  });
  document.querySelectorAll("[data-l7r-hide-sticky]").forEach(function (el) {
    el.l7rInView = false;
    zoneObserver.observe(el);
  });

  l7rUpdateSticky();
}

$(document).on("click", "[data-l7r-shade]", function () {
  l7rSelectShade($(this));
});

$(document).on("mouseenter touchstart", "[data-l7r-shade]", function () {
  l7rPreloadShade($(this));
});

$(document).on("click", "[data-l7r-atc]", function (e) {
  e.preventDefault();
  l7rAddToCart($(this));
});

$(document).on("click", "[data-l7r-faq]", function () {
  l7rToggleFaq($(this));
});

$(document).ready(function () {
  l7rInitSticky();
});
